import { externalRedirect, setErrorReporterSessionData, updateLocale } from '@americanexpress/one-app-ducks';
import getSafeLocaleUtil from '../utils/getSafeLocaleUtil';
import { getAkamaiDomain } from '../selectors/getConfigSelectors';

const onEnterSetLocaleFromRoutePath = ({ getState, dispatch }) => async (props, onLoadComplete) => {
  const { locale: unsafeLocale } = props.params;
  const safeLocale = getSafeLocaleUtil(unsafeLocale, dispatch);
  const state = getState();
  const appDomain = getAkamaiDomain(state);

  // redirect to akamai for india market
  if (unsafeLocale
    && unsafeLocale.toLowerCase() !== getSafeLocaleUtil(unsafeLocale, dispatch).toLowerCase()
    && unsafeLocale.toLowerCase() === 'en-in'
  ) {
    const enInRedirectUrl = `${appDomain}/en-in/travel/`;
    await dispatch(externalRedirect(enInRedirectUrl));
    return;
  }

  if (unsafeLocale && unsafeLocale.toLowerCase() !== safeLocale.toLowerCase()) {
    const redirectUrl = `${props?.location?.pathname.replace(unsafeLocale, safeLocale.toLowerCase())}${props?.location?.search}`;
    await dispatch(externalRedirect(redirectUrl));
  }

  await dispatch(updateLocale(safeLocale));

  try {
    await dispatch(setErrorReporterSessionData({ activeLocale: safeLocale }));
  } catch (e) {
    // putting this here to prevent the app from crashing if the error reporter session data fails
  }

  onLoadComplete();
};

export default onEnterSetLocaleFromRoutePath;
